import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import Config from '../../../Config';
import {iconsType, infrastructure} from '../../../constans/salePackageEnum';
import {setSelectedPackage, setRouterParams, reportDWH, setIsCustomerSelectPackage} from './salePackagesBlockSlice';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Navigation, Pagination} from 'swiper';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import PopUp from '../../Shared/Popup/PopUp';
import SalePackage from './SalePackage';
import './salePackagesRouterPopup.scss';
import {prepareUrl} from '../../../utilities/StringHelpers/StringHelpers';
import AbroadPopularSwiper from '../AbroadPopularSwiper/AbroadPopularSwiper';

SwiperCore.use([Pagination, Navigation]);

const resolveRouterPopup = (packageItem, isDisabled) => {
  if (isDisabled) {
    return null;
  }

  const title = packageItem?.routerTitle || '';
  const content = packageItem?.routerContent || '';
  const image = packageItem?.routerImage || '';

  if (!title && !content && !image) {
    return null;
  }

  return {title, content, image};
};

const SalePackages = (props) => {
  const isIdf = props?.isIdf ? true : false;
  const blockID = props?.iContent?.contentLink?.id;
  const packagesList = props.packages?.salePackages?.expandedValue || props.packages?.salePackages || props.packages?.expandedValue;
  const buttonTextAllPackges = props.packages?.buttonTextAllPackges;
  const linkButton = props.packages?.linkButton;
  const isChangePP = props.isChangePricePlan;

  let isSwiper = true;
  if (props.isSwiper === false) {
    isSwiper = false;
  }
  const [packages, setPackages] = useState([]);
  const [showPopUp, setShowPopUp] = useState(false);
  const [activeRouterPopup, setActiveRouterPopup] = useState(null);

  useEffect(() => {
    let arrayPackages = [];
    let saleType = '';
    if (!props.packages?.isAbroadPackages) {
      packagesList?.forEach((item) => {
        let features = [];
        let extraFeatures = [];

        //---------------- features ----------------
        item.features?.expandedValue?.forEach((item) => {
          let feature = {
            title: item?.title?.value,
            featureList: [],
          };

          item.featureList?.expandedValue?.forEach((item) => {
            feature.featureList.push({
              text: item.text.value,
              isBoldText: !!item.isBoldText.value,
              iconType: iconsType[item.icon.value],
              featureLink: item.featureLink.value,
            });
          });

          features.push(feature);
        });

        item.extraFeatures?.expandedValue?.forEach((item) => {
          let extraFeature = {
            title: item?.title?.value,
            featureList: [],
          };

          item.featureList?.expandedValue?.forEach((item) => {
            extraFeature.featureList.push({
              text: item.text.value,
              isBoldText: !!item.isBoldText.value,
              iconType: iconsType[item.icon.value],
              featureLink: item.featureLink.value,
            });
          });

          extraFeatures.push(extraFeature);
        });
        //---------------- features ----------------

        const infrastructureList =
          item.infrastructures?.value?.map((item) => {
            return infrastructure[item.infrastructure];
          }) ?? [];

        saleType = getSaleTypeName(item.saleType.value);

        if (saleType == 'internet' || saleType == 'triple') {
          if (props.infrastructure && !infrastructureList.includes(props.infrastructure)) {
            return null;
          }
        }

        const upgradeDetails = {
          title: item.upgradeTitle?.value,
          text: item.upgradeText?.value,
          image: item.upgradeIcon.value?.url,
          buttonYesText: item.upgradeButtonYes?.value,
          buttonNoText: item.upgradeButtonNo?.value,
          package: item.salePackageForUpgrade?.expandedValue ? item.salePackageForUpgrade?.expandedValue[0] : null,
        };

        const familyPackageSapFields = {
          productID: item.productID?.value,
          productIDPortIn: item.productIDPortIn?.value,
          bpKey: item.bpKey?.value,
          package: item.package?.value,
          packagePortIn: item.packagePortIn?.value,
          combSeq: item.combSeq?.value,
          combSeqPortIn: item.combSeqPortIn?.value,
          zterm: item.zterm?.value,
        };

        const transferBussinessCustomer = {
          productId_SIM: item.productId_SIM?.value,
          productId_eSIM: item.productId_eSIM?.value,
          package_SIM: item.package_SIM?.value,
          package_eSIM: item.package_eSIM?.value,
          combSeq_SIM: item.combSeq_SIM?.value,
          combSeq_eSIM: item.combSeq_eSIM?.value,
        };

        const salePackage = {
          blockID: item.contentLink.id,
          //saleType: salePackageType[item.saleType.value],
          offerID: item.offerID.value,
          saleType: saleType,
          orderType: item.orderType.value,
          infrastructures: infrastructureList,
          isXgspon: !!item.isXgspon?.value,
          link: item.link.value,
          isCounter: item.isCounter.value,
          counterDate: new Date() > new Date(item.counterDate.value) ? null : item.counterDate.value,
          benefitTitle: item.benefitTitle.value,
          benefitIcon: item.benefitIcon?.value?.url,
          downloadSpeed: item.downloadSpeed?.value,
          uploadSpeed: item.uploadSpeed?.value,
          title: item.title.value,
          subTitle: item.subTitle.value,
          headerBackgroundColor: item?.headerBackgroundColor?.value,
          whiteBackgroundColor: item?.whiteBackgroundColor?.value,
          subTitleIconUrl: item.subTitleIcon?.value?.url,
          banner: item.banner?.value,

          headerOneTitle: item?.headerOneTitle?.value,
          headerFirstFeatureText: item?.headerLeftFeatureText?.value,
          headerFirstFeatureIcon: item?.headerLeftFeatureIcon?.value?.url,
          headerFirstFeatureTextBold: item?.headerLeftFeatureTextBold?.value,
          headerTwoTitle: item?.headerTwoTitle?.value,
          headerSecondFeatureText: item?.headerRightFeatureText?.value,
          headerSecondFeatureIcon: item.headerRightFeatureIcon?.value?.url,
          headerSecondFeatureTextBold: item?.headerRightFeatureTextBold?.value,
          headerThirdTitle: item?.headerThirdTitle?.value,
          headerThirdFeatureText: item?.headerThirdFeatureText?.value,
          headerThirdFeatureIcon: item?.headerThirdFeatureIcon?.value?.url,
          headerThirdFeatureTextBold: item?.headerThirdFeatureTextBold?.value,
          headerFourthTitle: item?.headerFourthTitle?.value,
          headerFourthFeatureText: item?.headerFourthFeatureText.value,
          headerFourthFeatureIcon: item?.headerFourthFeatureIcon?.value?.url,
          headerFourthFeatureTextBold: item?.headerFourthFeatureTextBold.value,

          textBeforePrice: item.textBeforePrice?.value,
          isTextBeforePriceCloseToPrice: !!item.isTextBeforePriceCloseToPrice?.value,
          price: item.price?.value,
          priceText: item.priceText?.value,
          isPriceText: item.isPriceText?.value,
          textBeforPriceRowTwo: item?.textBeforPriceRowTwo?.value,
          oldPriceTwo: item?.oldPriceTwo?.value,
          priceNotDel: item?.priceNotDel?.value,
          textUnderPrice: item.textUnderPrice?.value,
          oneTimeFee: item.oneTimeFee?.value,
          routerInfo: item.routerInfo?.expandedValue ? item.routerInfo?.expandedValue[0] : '',
          isShowPopUpEpi: item?.isShowPopUpEpi,
          defaultConvertersAmount: item.defaultConvertersAmount.value,
          minimumConvertersAmount: item.minimumConvertersAmount.value,
          programDetailsLink: item.programDetailsLink.value,
          connectionAgreementLink: item.connectionAgreementLink?.value,
          routerText: item.routerText.value,
          routerTitle: item.routerTitle?.value,
          routerContent: item.routerContent?.value,
          routerImage: item.routerImage?.value?.url,
          buttonText: item.buttonText.value,
          tagColor: item.tagColor?.value,
          tagColorText: item.tagColorText?.value,
          features: features,
          extraFeatures: extraFeatures,
          addons: item.addons?.expandedValue,
          isSelectedCellcomRouter: item.routerText.value ? true : false,
          selectedRouterName: item.routerText.value
            ? item.routerInfo?.expandedValue
              ? item.routerInfo?.expandedValue[0]?.cellcomRouterName?.value
              : ''
            : '',
          isIncludeForeignRouter: item.routerInfo?.expandedValue ? item.routerInfo?.expandedValue[0].isIncludeForeignRouter.value : '',
          isShowMoreDetails: false,
          termsLink: item.termsLink.value,
          isCustomerBasedPackage: !!item.isCustomerBasedPackage.value,
          isDisplayEsim: !!item.isDisplayEsim.value,
          isBenefitsForSoldiers: !!item.isBenefitsForSoldiers.value,
          fileUpload: item.fileUpload,
          isFamilyPackage: !!item.isFamilyPackage.value,
          isImmediateTransitionPlan: !!item.isImmediateTransitionPlan?.value,
          upgradeDetails: upgradeDetails,
          familyPackageSapFields: familyPackageSapFields,
          isSmartMeterPackage: !!item.isSmartMeterPackage?.value,
          isSuitableForAllMeterTypesPackage: !!item.isSuitableForAllMeterTypesPackage?.value,
          transferBussinessCustomer: transferBussinessCustomer,
          couponList: item.couponList?.expandedValue,
          pricePlanCode: item.pricePlanCode?.value,
        };
        if (salePackage.orderType == 2 || props.orderType != 'replace') {
          arrayPackages.push(salePackage);
        }
      });
      setPackages(arrayPackages);
    }
    if (props.gtag4) {
      props.gtag4({
        event: `${saleType}_Step1_PackagesPageImp`,
        step: '1',
        action: 'PackagesPageImp',
        funnel_name: 'Choose_Package',
      });
    }
  }, [props.packages, props.infrastructure]);

  const packageResponse = (selectedPackage, isSelectedCellcomRouter) => {
    return {
      blockID: selectedPackage.blockID,
      offerID: selectedPackage.offerID,
      saleType: selectedPackage.saleType,
      title: selectedPackage.title,
      banner: selectedPackage.banner,
      downloadSpeed: selectedPackage.downloadSpeed,
      uploadSpeed: selectedPackage.uploadSpeed,
      infrastructures: selectedPackage.infrastructures,
      isXgspon: selectedPackage.isXgspon,
      isSelectedCellcomRouter: isSelectedCellcomRouter,
      selectedRouterName: isSelectedCellcomRouter
        ? selectedPackage.routerInfo?.cellcomRouterName?.value
        : selectedPackage.routerInfo?.foreignRouterName?.value,
      defaultConvertersAmount: selectedPackage.defaultConvertersAmount,
      minimumConvertersAmount: selectedPackage.minimumConvertersAmount,
      link: selectedPackage.link,
      programDetailsLink: selectedPackage.programDetailsLink,
      connectionAgreementLink: selectedPackage.connectionAgreementLink,
      termsLink: selectedPackage.termsLink,
      oneTimeFee: selectedPackage.oneTimeFee,
      price: selectedPackage.price,
      textBeforePrice: selectedPackage.textBeforePrice,
      priceText: selectedPackage.priceText,
      benefitTitle: selectedPackage.benefitTitle,
      buttonText: selectedPackage.buttonText,
      addons: selectedPackage.addons,
      isCustomerBasedPackage: selectedPackage.isCustomerBasedPackage,
      isDisplayEsim: selectedPackage.isDisplayEsim,
      isBenefitsForSoldiers: selectedPackage.isBenefitsForSoldiers,
      fileUpload: selectedPackage.fileUpload,
      upgradeDetails: selectedPackage.upgradeDetails,
      isFamilyPackage: selectedPackage.isFamilyPackage,
      familyPackageSapFields: selectedPackage.familyPackageSapFields,
      isSmartMeterPackage: selectedPackage.isSmartMeterPackage,
      isSuitableForAllMeterTypesPackage: selectedPackage.isSuitableForAllMeterTypesPackage,
      routerInfo: selectedPackage.routerInfo,
      isShowPopUpEpi: selectedPackage.isShowPopUpEpi,
      isImmediateTransitionPlan: selectedPackage.isImmediateTransitionPlan,
      transferBussinessCustomer: selectedPackage.transferBussinessCustomer,
      couponList: selectedPackage.couponList,
      pricePlanCode: selectedPackage.pricePlanCode,
    };
  };

  function onClickShowMoreDetails({e, item}) {
    if (isIdf) {
      e.stopPropagation();
    }
    const newPackages = packages.map((obj) => {
      if (obj.blockID === item.blockID) {
        return {...obj, isShowMoreDetails: !obj.isShowMoreDetails};
      }
      return obj;
    });
    setPackages(newPackages);
    if (props.gtag4) {
      props.gtag4({
        event: 'CarouselPackagesSale_InfoButton',
        category: props.textTab,
        section: 'CarouselPackagesSale',
        button: item.isShowMoreDetails ? 'סגירה' : 'למידע נוסף',
        package_name: props.switchExtraction(item.title),
        badge: item.banner ? item.banner : 'no badge',
      });
    }
  }

  function onSelectedSalePackage(salePackage, index) {
    props.setSelectedPackage(salePackage);
    props.setIsCustomerSelectPackage();
    const packageResponseObj = packageResponse(salePackage, salePackage.isSelectedCellcomRouter);
    if (props.isOrgPlan) props.onSelectedPackages(index);
    else props.onSelectedPackages(packageResponseObj);

    if (props.gtag4) {
      props.gtag4({
        event: 'CarouselPackagesSale_ContinueButton',
        category: props.textTab,
        section: 'CarouselPackagesSale',
        button: salePackage.buttonText,
        package_name: props.switchExtraction(salePackage.title),
        badge: salePackage.banner ? salePackage.banner : 'no badge',
      });
    }

    const regex = /<p[^>]*>(.*?)<\/p>/g;
    const matches = salePackage?.title?.match(regex);
    const itemName = matches ? matches.map((match) => match.replace(/<\/?p[^>]*>/g, '')).join(' ') : '';
    const listName = salePackage?.saleType + '_packages_list';
  }

  function onClickShowRouterDetails(salePackage) {
    props.setSelectedPackage(salePackage);
    setActiveRouterPopup(resolveRouterPopup(salePackage, props.isRouterPopupDisabled));
    props.reportDWH({
      actionType: 'Select Offer',
      status: 'Ongoing',
      messageText: 'Offer Router i Icon Clicked',
    });
    setShowPopUp(true);
  }

  function onClickPopUpRouterBtn(isSelectedCellcomRouter) {
    props.setIsCustomerSelectPackage();
    props.setRouterParams(isSelectedCellcomRouter);
    props.reportDWH({
      actionType: 'Router Popup',
      status: 'Ongoing',
      messageText: isSelectedCellcomRouter ? 'I Need Router Button Clicked' : 'I Dont Need Router Button Clicked',
    });
    const packageResponseObj = packageResponse(props.selectedPackage, isSelectedCellcomRouter);
    props.onSelectedPackages(packageResponseObj);
  }

  const routerImage = (routerPopup) => {
    if (routerPopup?.image) {
      return <Image className='router-image' src={Config.epiBaseUrl + routerPopup.image} />;
    }
    return null;
  };

  function closePopUp() {
    setShowPopUp(false);
  }

  function getSaleTypeName(saleType) {
    switch (saleType) {
      case null:
      case 0:
        return 'tv';
      case 1:
        return 'app';
      case 2:
        return 'cellular';
      case 3:
        return 'internet';
      case 4:
        return 'triple';
      case 5:
        return 'energy';
      default:
        return 'tv';
    }
  }

  const handelClickButton = () => {
    if (linkButton != null) {
      prepareUrl(linkButton, props.context);
    }
    if (props.gtag4) {
      props.gtag4({
        event: 'CarouselPackagesSale_MorePackagesButton',
        category: props.textTab,
        section: 'CarouselPackagesSale',
        button: buttonTextAllPackges,
      });
    }
  };
  const selectedPackage = (item) => {
    if (isIdf) {
      if (Object.keys(props.selectedPackage).length > 0) {
        if (item?.addons?.length > 0) {
          if (props.selectedPackage?.addons?.[0].id?.value === item.addons[0].id.value) {
            return true;
          }
        }
      }
      return false;
    }
    if (props.isOrgPlan || props.setBorder) {
      return props.selectedPackage?.offerID === item.offerID;
    }
    return false;
  };
  return (
    <>
      <div className='sale-packages'>
        <div className={`packages ${props?.packages?.lobbyFolderReference?.value && !isChangePP ? 'abroad' : ''}${isIdf ? ' is-idf' : ''}`}>
          {isSwiper && !props.packages?.isAbroadPackages ? (
            <Swiper
              className='swiper-item'
              modules={[Navigation]}
              navigation={packages.length > 1 ? true : false}
              centerInsufficientSlides={true}
              spaceBetween={15}
              slidesPerView={'auto'}
              centeredSlides={true}
              breakpoints={{
                440: {
                  centeredSlides: false,
                }
              }}
              // slidesOffsetBefore={16}
              // slidesOffsetAfter={16}
              // scrollbar={{draggable: true}}
              enabled={true}>
              {packages?.map((item, i) => {
                return (
                  <SwiperSlide key={i}>
                    <SalePackage
                      item={item}
                      routerPopup={resolveRouterPopup(item, props.isRouterPopupDisabled)}
                      onClickShowRouterDetails={onClickShowRouterDetails}
                      onSelectedSalePackage={onSelectedSalePackage}
                      onClickShowMoreDetails={onClickShowMoreDetails}
                      i={i}
                      isIdf={isIdf}
                      isSelectedPackage={selectedPackage(item)}
                      isOrgPlan={props.isOrgPlan}
                      setBorder={props.setBorder}
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          ) : isSwiper && props?.packages?.isAbroadPackages ? (
            <AbroadPopularSwiper
              context={props?.context}
              blockID={blockID}
              lobbyFolderReference={props?.packages?.lobbyFolderReference}
              gtag4={props?.gtag4}
              textTab={props?.textTab}
              switchExtraction={props?.switchExtraction}></AbroadPopularSwiper>
          ) : (
            <div className='no-swiper'>
              {packages?.map((item, i) => (
                <SalePackage
                  key={i}
                  item={item}
                  routerPopup={resolveRouterPopup(item, props.isRouterPopupDisabled)}
                  onClickShowRouterDetails={onClickShowRouterDetails}
                  onSelectedSalePackage={onSelectedSalePackage}
                  onClickShowMoreDetails={onClickShowMoreDetails}
                  i={i}
                />
              ))}
            </div>
          )}
        </div>
        {activeRouterPopup && (
          <PopUp showPopUp={showPopUp} onClose={closePopUp} className='sale-packages-router-popup'>
            <h2>{activeRouterPopup.title}</h2>
            {routerImage(activeRouterPopup)}
            <div className='content' dangerouslySetInnerHTML={{__html: activeRouterPopup.content}}></div>
            <div className='btn-wrapper'>
              <button className='btn-router' onClick={() => onClickPopUpRouterBtn(true)}>
                כן, אני רוצה נתב
              </button>
              <button onClick={() => onClickPopUpRouterBtn(false)} className='btn-no-router'>
                אני רוצה חבילה בלי נתב
              </button>
            </div>
          </PopUp>
        )}
      </div>
      {buttonTextAllPackges && (
        <button className='button-packages' onClick={handelClickButton}>
          {buttonTextAllPackges}
        </button>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedPackage: state.SalePackagesBlock.selectedPackage,
    abroadPackagesPopularMarket: state?.cellcomAbroad?.abroadPackagesPopularMarket,
  };
};

const mapDispatchToProps = {
  setSelectedPackage,
  setRouterParams,
  reportDWH,
  setIsCustomerSelectPackage,
};

export default connect(mapStateToProps, mapDispatchToProps)(SalePackages);
